import { getRuntimeEnv } from "./runtimeConfig";

export const isDevEnv = (): boolean => {
  const host = window.location.host;
  return host.includes('localhost') ||
    host.includes('dev01') ||
    host.includes('dev02') ||
    host.includes('test01')
    ;
}

/**
 * True when the app runs inside an iframe (embedded within the QuestDIY shell /
 * survey builder). False when a respondent opens the survey link directly.
 * Falls back to `true` if cross-origin access to `window.top` throws.
 */
export const isEmbedded = (): boolean => {
  try {
    return window.self !== window.top && window.origin !== getRuntimeEnv('VITE_SURVEY_BUILDER_URL', import.meta.env.VITE_SURVEY_BUILDER_URL);
  } catch {
    return true;
  }
}

